module.exports = __webpack_public_path__ + "ff1dd9f017edf0f7f39d8b96a409185e.png";